import { apiRequest } from './client'

export interface CollectionData {
  state_key: string
  count: number
  items: Record<string, unknown>[]
}

export function getCollection(projectId: string, stateKey: string): Promise<CollectionData> {
  return apiRequest<CollectionData>(`/api/projects/${projectId}/collections/${stateKey}`)
}

export function deleteCollection(projectId: string, stateKey: string): Promise<void> {
  return apiRequest<void>(`/api/projects/${projectId}/collections/${stateKey}`, { method: 'DELETE' })
}
